import UpdateReferenceDialog from './UpdateReferenceDialog';

export * from './UpdateReferenceDialogProps';
export default UpdateReferenceDialog;
